export const API_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'https://prod-be-bip.alpha-filter.xyz/api/v1'
    : 'https://prod-be-bip.alpha-filter.xyz/api/v1';
